/* @flow */

/**
 * Returns a currency prefix for provided currency.
 * If no value is provided, the default is 'usd
 *
 * @method getCurrencySymbol
 * @param {string} formValue
 * @param {string} currencyPref
 * @return {string}
 */
export const getCurrencySymbol: Function = (formValue, currencyPref = 'usd'): string => {
  const value: string = formValue || currencyPref;

  switch (value.toLowerCase()) {
    case 'dollars':
    case 'usd':
      return '$ ';
    case 'pounds':
    case 'gbp':
      return '£ ';
    case 'euros':
    case 'eur':
      return '€ ';
  }

  return value;
};

/**
 * Returns a rate literal for a rate code.
 *
 * @param rate
 * @param _default
 * @returns {string}
 */
export const getRate: Function = (rate, _default): string => {
  const value: string = rate || _default;

  switch (value) {
    case 'productLocalRentalPriceWeekly':
      return 'Weekly Rental Rate';
    case 'productLocalRentalPriceMonthly':
      return 'Monthly Rental Rate';
    case 'productLocalRentalPriceMonthlyStd':
      return 'STD Monthly Rental Rate';
  }

  return value;
};

export const getUserSeparatorValues: Function = (): Object => {
  const activeUser: Object = JSON.parse(localStorage.getItem('user'));
  const thousandSeparator: string = activeUser.price_format.match(/^\d+(,\d{3})*(\.\d{1,2})?$/g)
    ? ','
    : '.';
  const decimalSeparator: string = activeUser.price_format.match(/^\d+(,\d{3})*(\.\d{1,2})?$/g)
    ? '.'
    : ',';

  return { thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator };
};

export default getCurrencySymbol;
